export class TicketTextI18NOutDTO {
  en!: string;
  fr!: string;
  nl!: string;
}
